const BASE_URL = process.env.REACT_APP_DGPV_API_URL;
const FACTORY_TOOL_URL = process.env.REACT_APP_FACTORY_TOOL_URL;
const PLATFORM_DEVICES_URL = process.env.REACT_APP_PLATFORM_DEVICES_URL;
const CLUSTER_DEVICE_URL = process.env.REACT_APP_CLUSTER_DEVICE_URL;
const WARROOM_URL = process.env.REACT_APP_WARROM_URL;
const PLATFORM_DEVICES_URL_CUSTOMER =
  process.env.REACT_APP_PLATFORM_DEVICES_URL_CUSTOMER;

const apiUrls = {
  login: `${BASE_URL}/auth/login`,
  refresh: `${BASE_URL}/auth/refresh`,
  logout: `${BASE_URL}/auth/logout`,
  updateDeviceInfo: `${BASE_URL}/device`,
  getAccessToken: `${FACTORY_TOOL_URL}/api/jwt/access-token/`,
  updateDeviceModbus: (deviceId) =>
    `${FACTORY_TOOL_URL}/api/device/${deviceId}/modbus-config/`,
  getModbusData: (modbusId) =>
    `${FACTORY_TOOL_URL}/api/modbus-config/${modbusId}/`,
  getPatchData: (deviceId) => `${FACTORY_TOOL_URL}/api/patch/${deviceId}/`,
  getPatchCode: (patchId) => `${FACTORY_TOOL_URL}/api/patch/${patchId}/`,
  updateInterface: (interfaceId) =>
    `${FACTORY_TOOL_URL}/api/device/interfaces/${interfaceId}/`,
  savePatch: (deviceId) => `${FACTORY_TOOL_URL}/api/device/${deviceId}/patch/`,
  saveDeviceGroupInterface: (deviceId, interfaceId) =>
    `${FACTORY_TOOL_URL}/api/device/${deviceId}/interface/${interfaceId}/`,
  groupAttributes: (deviceId, keys) =>
    `${FACTORY_TOOL_URL}/api/device/${deviceId}/attributes?keys=${keys}`,
  toolDeviceAttributes: (deviceId, keys) =>
    `${FACTORY_TOOL_URL}/api/v1/${deviceId}/attributes?keys=${keys}`,
  toolDeviceAttributesV1: (PLATFORM_ID, groupID, configId, keys) =>
    `${FACTORY_TOOL_URL}/api/v1/platform/${PLATFORM_ID}/group/${groupID}/config/${configId}/attributes?keys=${keys}`,
  allDevices: (serialNumber, page = 0, sortOrder = 'DESC') =>
    `${PLATFORM_DEVICES_URL}?pageSize=10&page=${page}&textSearch=${serialNumber}&sortProperty=active&active&sortOrder=${sortOrder}`,
  deviceAttributes: (deviceId, keys) =>
    `${BASE_URL}/plugins/telemetry/DEVICE/${deviceId}/values/attributes?keys=${keys}`,
  updateDevice: (deviceId) =>
    `${BASE_URL}/plugins/telemetry/DEVICE/${deviceId}/SHARED_SCOPE`,
  deviceTsData: (deviceId, start, end, limit, interval, keys) =>
    `${BASE_URL}/plugins/telemetry/DEVICE/${deviceId}/values/timeseries?startTs=${start}&endTs=${end}&limit=${limit}&interval${interval}&keys=${keys}`,
  // uploadThresholds expects a modbus-config id (or other id to target) and returns the URL
  uploadThresholds: (modbusConfigId) =>
    `${FACTORY_TOOL_URL}/api/modbus-config/${modbusConfigId}/parameters/`,
  activeDevices: (activeOnly = true) =>
    `${BASE_URL}/deviceProfile/names?activeOnly=${activeOnly}`,

  getRelationInfo: (deviceId) =>
    `${BASE_URL}/relations/info?toId=${deviceId}&toType=DEVICE`,

  getAdditionalInfo: (assetId) => `${BASE_URL}/asset/${assetId}`,

  factorytoolgroupAttributes: (deviceId, keys) =>
    `${FACTORY_TOOL_URL}/api/v1/${deviceId}/attributes?keys=${keys}`,

  fetchModbusConfigsandpatches: (platformId, groupID, keys) =>
    `${FACTORY_TOOL_URL}/api/v1/platform/${platformId}/group/${groupID}/attributes?keys=${keys}`,

  deleteModbusConfig: (configId) =>
    `${FACTORY_TOOL_URL}/api/modbus-config/${configId}/delete/`,

  updateConfig: (PLATFORM_ID, groupId) =>
    `${FACTORY_TOOL_URL}/api/v1/platform/${PLATFORM_ID}/group/${groupId}/config`,
  deletePatch: (patchId) => `${FACTORY_TOOL_URL}/api/patch/${patchId}/delete/`,
  updatePatch: (PLATFORM_ID, groupId) =>
    `${FACTORY_TOOL_URL}/api/v1/platform/${PLATFORM_ID}/group/${groupId}/patch`,
  getPatchCodeV1: (PLATFORM_ID, groupID, patchId, keys) =>
    `${FACTORY_TOOL_URL}/api/v1/platform/${PLATFORM_ID}/group/${groupID}/patch/${patchId}/attributes?keys=${keys}`,

  assetResp: (assetName) => `${BASE_URL}/tenant/assets?assetName=${assetName}`,
  relationResp: (assetId) =>
    `${BASE_URL}/relations/info?fromId=${assetId}&fromType=ASSET`,

  getChildren: (entityId) =>
    `${BASE_URL}/relations/info?fromId=${entityId}&fromType=ASSET`,

  getCountries: () =>
    `${BASE_URL}/tenant/assets?pageSize=100&page=0&type=country`,

  getDevices: (Id) =>
    `${BASE_URL}/asset/info/${Id}/devices?pageSize=100&page=0`,
  getassetInfo: (assetId) => `${BASE_URL}/asset/info/${assetId}`,

  getClusterDevices: (Id) => `${CLUSTER_DEVICE_URL}/devices/${Id}`,
  /* ---------------- TEMPLATE APIs ---------------- */

  saveTemplateAsset: `${BASE_URL}/asset`,

  getTemplates: (page = 0, pageSize = 100, textSearch = '') =>
    `${BASE_URL}/tenant/assets?pageSize=${pageSize}&page=${page}&type=site-template&textSearch=${textSearch}`,

  getTemplateSchema: (assetId) =>
    `${BASE_URL}/plugins/telemetry/ASSET/${assetId}/values/attributes/SERVER_SCOPE`,

  saveTemplateSchema: (assetId) =>
    `${BASE_URL}/plugins/telemetry/ASSET/${assetId}/attributes/SERVER_SCOPE`,

  getTemplateInfo: (assetId) => `${BASE_URL}/asset/${assetId}`,

  // Get device attributes
  deviceAttributes: (deviceId) =>
    `${BASE_URL}/plugins/telemetry/DEVICE/${deviceId}/values/attributes/SERVER_SCOPE`,

  // Save device attributes
  saveDeviceAttributes: (deviceId) =>
    `${BASE_URL}/plugins/telemetry/DEVICE/${deviceId}/SERVER_SCOPE`,

  fetchDeviceHealth: (deviceId) =>
    `${WARROOM_URL}f_api/device-metrics/${deviceId}?keys=cpu,ram,disk,backup_available,total_backup_created,backup_file_size`,

  setConfigStatus: (PLATFORM_ID, groupId, configId) =>
    `${FACTORY_TOOL_URL}/api/v1/platform/${PLATFORM_ID}/group/${groupId}/config/${configId}/`,

  setPatchStatus: (PLATFORM_ID, groupId, patchId) =>
    `${FACTORY_TOOL_URL}/api/v1/platform/${PLATFORM_ID}/group/${groupId}/patch/${patchId}/`,

  fetchMetricsData: (deviceName, start, end, step, keys) =>
    `${WARROOM_URL}f_api/device-metrics/${deviceName}?keys=${keys}&start=${start}&end=${end}&step=${step}`,

  fetchAllModbusConfigs: (
    platformId,
    groupID,
    filterBy = '',
    searchBy = '',
    page = 1,
  ) =>
    `${FACTORY_TOOL_URL}/api/v1/platform/${platformId}/groups/${groupID}/modbus-configs/?filter_by=${filterBy}&search_by=${searchBy}&page=${page}`,
  fetchAllPatches: (
    platformId,
    groupID,
    filterBy = '',
    searchBy = '',
    page = '',
  ) =>
    `${FACTORY_TOOL_URL}/api/v1/platform/${platformId}/groups/${groupID}/patches/?filter_by=${filterBy}&page=${page}&search_by=${searchBy}`,
  fetchAllInterfaces: (platformId, groupID) =>
    `${FACTORY_TOOL_URL}/api/v1/platform/${platformId}/groups/${groupID}/interfaces/`,

  fetchAllDevices: (platformId, groupID) =>
    `${FACTORY_TOOL_URL}/api/v1/platform/${platformId}/groups/${groupID}/devices/`,
  fetchAllTelemetryKeys: (platformId, groupID) =>
    `${FACTORY_TOOL_URL}/api/v1/platform/${platformId}/groups/${groupID}/telemetry-keys/`,

  fetchAssetInfo: (page = 0, pageSize = 10, textSearch = '') =>
    `${BASE_URL}/tenant/assetInfos?pageSize=${pageSize}&page=${page}&textSearch=${textSearch}&sortProperty=createdTime&sortOrder=DESC`,

  fetchAssetInfoforCustomer: (
    page = 0,
    pageSize = 10,
    textSearch = '',
    customerId,
  ) =>
    `${BASE_URL}/customer/${customerId}/assetInfos?pageSize=${pageSize}&page=${page}&textSearch=${textSearch}&sortProperty=createdTime&sortOrder=DESC`,

  fetchUserDetails: (id) => `${BASE_URL}/user/${id}`,

  allDevicesofcustomer: (customerId, serialNumber, page = 0) =>
    `${PLATFORM_DEVICES_URL_CUSTOMER}/${customerId}/deviceInfos?pageSize=10&page=${page}&textSearch=${serialNumber}&sortProperty=id&active&sortOrder=DESC`,
};

export default apiUrls;
